import _tagged_template_literal from "@swc/helpers/src/_tagged_template_literal.mjs";
function _templateObject() {
    var data = _tagged_template_literal([
        "\n      padding-top: 4rem;\n      padding-bottom: 4rem;\n\n      ",
        " {\n        padding-top: 6rem;\n        padding-bottom: 6rem;\n      }\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
import styled from "@emotion/styled";
import { css } from "@emotion/react";
import { Theme, Styles } from "@silvertours/front-shared";
var getLayoutFlow = function(layoutFlow) {
    return ({
        top: /*#__PURE__*/ css("display:flex;flex-direction:column-reverse;"),
        bottom: /*#__PURE__*/ css("display:flex;flex-direction:column;"),
        left: /*#__PURE__*/ css("display:flex;flex-direction:column;", Theme.mq("sm"), "{display:grid;grid-template-columns:repeat(2,minmax(0,auto));}"),
        right: /*#__PURE__*/ css("display:flex;flex-direction:column;", Theme.mq("sm"), "{display:grid;grid-template-columns:repeat(2,minmax(0,auto));}")
    })[layoutFlow];
};
var getBackgroundColor = function(theme, style) {
    return ({
        default: "",
        gray: /*#__PURE__*/ css("background-color:", theme.color.natural10, ";"),
        green: "",
        mint: "",
        orange: ""
    })[style];
};
var getSpacingDirection = function(spacingDirection) {
    return ({
        top: /*#__PURE__*/ css("padding-top:4rem;padding-bottom:0;", Theme.mq("lg"), "{padding-top:6rem;}"),
        bottom: /*#__PURE__*/ css("padding-top:0;padding-bottom:4rem;", Theme.mq("lg"), "{padding-bottom:6rem;}"),
        both: "",
        neither: ""
    })[spacingDirection];
};
var Container = /*#__PURE__*/ styled("section", {
    target: "ejdft7l0"
})(Styles.Global.layoutContainerContent, "  gap:2.5rem;", function(param) {
    var theme = param.theme;
    return theme.mq("lg");
}, "{gap:3rem;}", function(param) {
    var isLarge = param.isLarge, layoutFlow = param.layoutFlow;
    return isLarge && layoutFlow && getLayoutFlow(layoutFlow);
}, ";", function(param) {
    var theme = param.theme, backgroundStyle = param.backgroundStyle;
    return backgroundStyle && getBackgroundColor(theme, backgroundStyle);
}, ";", function(param) {
    var isLarge = param.isLarge, _layoutFlow = param.layoutFlow, layoutFlow = _layoutFlow === void 0 ? "" : _layoutFlow;
    return isLarge && ![
        "left",
        "right"
    ].includes(layoutFlow) && css(_templateObject(), Theme.mq("xl"));
}, ";");
var WaveContainer = /*#__PURE__*/ styled(Container, {
    target: "ejdft7l1"
})("padding-top:2.5rem;padding-bottom:2.5rem;", function(param) {
    var spacingDirection = param.spacingDirection;
    return spacingDirection && getSpacingDirection(spacingDirection);
}, ";");
export { Container, WaveContainer };
